module.exports = __webpack_public_path__ + "media/images/site/marks-right-5d08d160d310d7f33371fb25fa1d47ee.svg";